export default __webpack_public_path__ + "static/media/1201.95b79758.png";